import { normalize } from 'normalizr';

import { callApi } from 'utils/api';
import * as schemas from 'schemas';

export function topicsFetch(type, category) {
  return callApi('/topics', {
    query: {
      type,
      category
    }
  })
  .then(json => {
    const { result, entities } = normalize(json, schemas.topicsArraySchema);
    return {topicsIds: result, entities};
  });
}

export function topicUpdate(id, updates) {
  return callApi('/topics', {
    method: 'PATCH',
    body: {
      id,
      ...updates
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/topics/api.js
 **/